import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import PitchForm from '../../../Pitch/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { DialogContentText } from '@material-ui/core'

export default function YourPitchDialog({ open, handleClose, initialValues, setPropChange }) {
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()
    setPropChange(true)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Your Pitch</DialogTitle>
      <DialogContentText>
        Clients using the Paro platform want to know all about YOU! Now is the time to impress clients with a pitch
        highlighting what makes you an elite finance/accounting freelancer.
      </DialogContentText>
      <StyledContent>
        <PitchForm initialValues={initialValues} />
      </StyledContent>
      <Divider />
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="primary">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
